import React from "react";
import { Navigate, useLocation } from "react-router-dom";

export const setToken = (token) => {
  localStorage.setItem('afrifaToken', token);
}

export const fetchToken = () => {
  return localStorage.getItem('afrifaToken');
}

export const setName = (name) => {
    localStorage.setItem('afrifaName', name);
}
export const fetchName = () => {
    return localStorage.getItem('afrifaName');
}

export const setRole = (role) => {
  localStorage.setItem('afrifaRole', role);
}

export const fetchRole = () => {
  return localStorage.getItem('afrifaRole');
}

export function RequireToken({ children }) {
  let auth = fetchToken();
  let location = useLocation();

  if (!auth) {
    // Token is missing, redirect to the login page
    return <Navigate to="/" state={{ from: location }} />;
  }

  // Token is present, render the children components
  return children;
}
